import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter, HostBinding, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'dots',
  template: `
    <div class="dot" *ngFor="let index of numbers" (click)="click(index)"
    [class.isDark]="!items[activeDot].isDark"
    [class.active]="activeDot === index"></div>
    `,
  styles: [`
        :host{
            position: absolute;
            display: inline-block;
            z-index: 1000;
        }
        :host(.left){
            bottom: 10px;
            left: 10px;
        }
        :host(.right){
            bottom: 10px;
            right: 10px;
        }
        :host(.middle){
            bottom: 20px;
            left: 50%;
            transform: translateX(-50%);
            -webkit-transform: translateX(-50%);
            -moz-transform: translateX(-50%);
            -o-transform: translateX(-50%);
            -ms-transform: translateX(-50%);
        }
        .dot{
            height: 14px;
            width: 14px;
            border-radius: 7px;
            background: white;
            opacity: .6;
            margin: 0 4px;
            display: inline-block;
        }
        .dot.isDark {
          background: #2B2B2B;
        }
        .dot:hover{
            opacity: .8;
            cursor: pointer;
        }
        .dot.active{
            opacity: .9;
        }
    `]
})

export class DotsComponent implements OnInit {
  numbers: Array<number>;

  // tslint:disable-next-line:no-input-rename
  @Input('active-dot') activeDot = 0;
  // tslint:disable-next-line:no-input-rename
  @Input('dots-count') dotsCount: number;
  @Input('items') items: any[];
  @HostBinding('class')
  @Input() position = 'left';


  @Output() buttonClick: EventEmitter<number> = new EventEmitter<number>();

  constructor() {
  }

  ngOnInit() {
    this.numbers = Array(this.dotsCount).fill(0).map((x, i) => i);
  }

  click(index: any) {
    this.buttonClick.emit(index);
    this.activeDot = index;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared-components/ui-carousel/dots.component.ts